import environment from '#/environment/environment';
import * as amplitude from '@amplitude/analytics-browser';
import {sessionReplayPlugin} from '@amplitude/plugin-session-replay-browser';
import * as Sentry from '@sentry/react';
import {useEffect} from 'react';
import {createRoutesFromChildren, matchRoutes, useLocation, useNavigationType} from 'react-router';

export const loadTrackersAndAnalytics = () => {
  // This is not being used.
  // if (environment.brazeApiKey) {
  //   initializeBraze();
  // }

  // if (environment.segmentIOApiKey) {
  //   loadAnalytics();
  // }
  const urlParams = new URLSearchParams(window.location.search);
  const amplitudeDeviceId = urlParams.get('amplitude_device_id');

  const amplitudeConfig = {
    autocapture: true,
    defaultTracking: true,
    ...(amplitudeDeviceId && {deviceId: amplitudeDeviceId}),
  };

  if (environment.sentryEnvironmentName) {
    Sentry.init({
      dsn: environment.sentryDsn,
      environment: environment.sentryEnvironmentName,
      integrations: [
        new Sentry.BrowserTracing({
          tracePropagationTargets: [environment.apiUrl],
          routingInstrumentation: Sentry.reactRouterV6Instrumentation(
            useEffect,
            useLocation,
            useNavigationType,
            createRoutesFromChildren,
            matchRoutes,
          ),
        }),
        new Sentry.Integrations.Breadcrumbs({
          console: false,
        }),
      ],
      tracesSampleRate: 0.5,
    });
  }

  if (environment.amplitudeApiKey) {
    const sessionReplayTracking = sessionReplayPlugin();
    amplitude.add(sessionReplayTracking);
    amplitude.init(environment.amplitudeApiKey, amplitudeConfig);
  }
};
